import { faEnvelope, faPaperPlane } from "@fortawesome/free-solid-svg-icons"
import { Dispatch, SetStateAction } from "react"
import UnForm from "../../../../Components/Form"
import { IComponentModal } from "../../../../Components/Modais/IModalComponent"
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage"
import { InserirEnvelopeController } from "../../../../Controllers/Geral/Envelopes/EnvelopesControllers"
import useAsyncCallback from "../../../../hooks/useAsyncCallback"
import { IInserirEnvelopeBody, IInserirEnvelopeResponse } from "../../../../Interfaces/Geral/Envelopes/EnvelopesInterface"
import ConfigurarEnvelopeEnvio from "../ConfigurarEvenlopeEnvio"

interface IEnviarEnvelopeModalProps {
   setShow: Dispatch<SetStateAction<boolean>>
   setModal: Dispatch<SetStateAction<IComponentModal | undefined>>
   envelopes: IInserirEnvelopeResponse
}

export default function EnviarEnvelopeModal(props: IEnviarEnvelopeModalProps){
    const { ID_CASO } = useAtendimentoPage()
    
    const {
        execute: executeInserirEnvelope,
        loading: inserirEnvelopeLoading
    } = useAsyncCallback(InserirEnvelopeController)
    
    function handleSubmitForm(formData: IInserirEnvelopeBody) {
        executeInserirEnvelope({
            ...formData,
            ID_CASO: ID_CASO,
            ID_ENVELOPE_DOCUSIGN_CONFIG: formData.ID_ENVELOPE_DOCUSIGN_CONFIG
        }).then((response) => {
            props.setModal({
                Component: () => <ConfigurarEnvelopeEnvio documentosAdicionais={response.LST_DOCUMENTOS_ADICIONAIS} idEnvelopeDocusignConfig={response.ID_ENVELOPE_DOCUSIGN_CONFIG}/>,
                headerComponent: 'Configuração de Envelope',
                IconHeader: faEnvelope,
                size: "xl"
            });
            
        })
    }

    return (
            <UnForm
                handleSubmit={handleSubmitForm}
            >
                <UnForm.Select 
                    name="ID_ENVELOPE_DOCUSIGN_CONFIG"
                    registerOptions={{
                        required: "Selecione um envelope"
                    }}
                >
                    <option></option>
                    
                    {props.envelopes && props.envelopes.LST_ENVELOPES.map((envelope) => (
                        <option
                            key={envelope.ID_ENVELOPE_DOCUSIGN_CONFIG}
                            value={envelope.ID_ENVELOPE_DOCUSIGN_CONFIG}
                        >
                            {envelope.DS_ENVELOPE}
                        </option>
                    ))}
                </UnForm.Select>

                <UnForm.SubmitButton
                    wrapperClassName="w-100 d-flex justify-content-end mt-5"
                    icon={faPaperPlane}
                    color="primary"
                    loading={inserirEnvelopeLoading}
                    disabled={inserirEnvelopeLoading}
                >
                    Selecionar Documento
                </UnForm.SubmitButton>
            </UnForm>
    )
}